const newTrackEvents = {
    "prizes": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'fantasy',
        contentSection3: 'prizes',
        pageTitle: 'UCL Classic Fantasy - Prizes',
        pageType: 'game prizes',
        pageName: '/uclfantasy/prizes/',
        pageFormat: 'standard view',
        type: "new"
    },
    "rules": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'fantasy',
        contentSection3: 'rules',
        pageTitle: 'UCL Classic Fantasy - Rules',
        pageType: 'game rules',
        pageName: '/uclfantasy/rules/',
        pageFormat: 'standard view',
        type: "new"
    },
    "help": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'fantasy',
        contentSection3: 'help',
        pageTitle: 'UCL Classic Fantasy - Help',
        pageType: 'help',
        pageName: '/uclfantasy/help/',
        pageFormat: 'standard view',
        type: "new"
    },
    "landingPage1": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy',
        contentSection3: 'landing',
        pageTitle: 'Fantasy - Landing Page (1st Visit)',
        pageType: 'landing',
        pageName: '/uclfantasy/landing/1st',
        pageFormat: 'standard view',
        type: "new"
    },
    "landingPage2": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy',
        contentSection3: 'landing',
        pageTitle: 'Fantasy - Landing Page (2nd Visit)',
        pageType: 'landing',
        pageName: '/uclfantasy/landing/2nd',
        pageFormat: 'standard view',
        type: "new"
    },
    "landingPage3": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy',
        contentSection3: 'landing',
        pageTitle: 'Fantasy - Landing Page (3rd Visit)',
        pageType: 'landing',
        pageName: '/uclfantasy/landing/3rd',
        pageFormat: 'standard view',
        type: "new"
    },
    "substitution": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy substitutions mode',
        contentSection3: '',
        pageTitle: 'Fantasy - Substitutions mode',
        pageType: 'game entry',
        pageName: '	/uclfantasy/my-team/substitutions/',
        pageFormat: 'standard view',
        type: "new"
    },
    "transfer": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy transfer mode',
        contentSection3: '',
        pageTitle: 'Fantasy - Transfers mode',
        pageType: 'game entry',
        pageName: '/uclfantasy/my-team/transfers/',
        pageFormat: 'standard view',
        type: "new"
    },
    "live": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'my team locked',
        contentSection3: '',
        pageTitle: 'Fantasy - My team locked (during live)',
        pageType: 'fantasy team',
        pageName: '/uclfantasy/my-team/view/',
        pageFormat: 'standard view',
        type: "new"
    },
    "globalRank": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy global overall',
        contentSection3: 'global rank leagues',
        pageTitle: 'global rank',
        pageType: 'leaderboard',
        pageName: '/uclfantasy/leagues/public/global rank/',
        pageFormat: 'standard view',
        type: "new"
    },
    "country": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy country',
        contentSection3: 'global rank leagues',
        pageTitle: 'country league',
        pageType: 'leaderboard',
        pageName: '/uclfantasy/leagues/public/{country}/',
        pageFormat: 'standard view',
        type: "new"
    },
    "club": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy club',
        contentSection3: 'global rank leagues',
        pageTitle: 'club league',
        pageType: 'leaderboard',
        pageName: '/uclfantasy/leagues/public/{club}/',
        pageFormat: 'standard view',
        type: "new"
    },
    "knockout": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy club',
        contentSection3: 'global rank leagues',
        pageTitle: 'knockout league',
        pageType: 'leaderboard',
        pageName: '/uclfantasy/leagues/public/{knockout}/',
        pageFormat: 'standard view',
        type: "new"
    },
    "emptyLeague": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy empty league',
        contentSection3: 'leagues',
        pageTitle: 'Leagues - empty',
        pageType: 'empty state',
        pageName: '/uclfantasy/leagues/empty/',
        pageFormat: 'standard view',
        type: "new"
    },
    "emptyLeagueDetails": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy empty league',
        contentSection3: 'leagues',
        pageTitle: 'League detail empty',
        pageType: 'empty state',
        pageName: '/uclfantasy/leagues/private/empty/',
        pageFormat: 'standard view',
        type: "new"
    },
    "LeagueDetails": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy league',
        contentSection3: 'leagues',
        pageTitle: 'League detail active',
        pageType: 'leaderboard',
        pageName: '/uclfantasy/leagues/private/',
        pageFormat: 'standard view',
        type: "new"
    },
    "LeagueInviteLayer": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy league invite',
        contentSection3: 'leagues',
        pageTitle: 'League invite layer',
        pageType: 'share',
        pageName: '/uclfantasy/leagues/private/invite/',
        pageFormat: 'standard view',
        type: "new"
    },
    "LeagueSettings": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy league',
        contentSection3: 'leagues',
        pageTitle: 'League settings',
        pageType: 'settings',
        pageName: '/uclfantasy/leagues/private/settings/',
        pageFormat: 'standard view',
        type: "new"
    },
    "LeagueSettingsEdit": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy league edit',
        contentSection3: 'leagues',
        pageTitle: 'League settings edit',
        pageType: 'settings',
        pageName: '/uclfantasy/leagues/private/settings/edit/',
        pageFormat: 'standard view',
        type: "new"
    },
    "createLeague": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy',
        contentSection3: 'leagues',
        pageTitle: 'Create league',
        pageType: 'create league',
        pageName: '/uclfantasy/leagues/private/create/',
        pageFormat: 'standard view',
        type: "new"
    },
    "joinLeague": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy',
        contentSection3: 'leagues',
        pageTitle: 'Join league layer',
        pageType: 'join league',
        pageName: '/uclfantasy/leagues/private/join/',
        pageFormat: 'standard view',
        type: "new"
    },
    "viewOthersTeam": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy others team view',
        contentSection3: 'leagues',
        pageTitle: 'View others team',
        pageType: 'fantasy team',
        pageName: '/uclfantasy/leagues/others-team/',
        pageFormat: 'standard view',
        type: "new"
    },
    "myTeam": {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'manage my team',
        contentSection3: '',
        pageTitle: 'UCL Classic Fantasy - Fantasy - My team (transfers or subs mode)',
        pageType: 'fantasy team',
        pageName: '/uclfantasy/my-team/manage/',
        pageFormat: 'standard view',
        type: "new"
    },
    'substitution': {
        event: 'Page Meta',
        contentSection1: 'gaminghub',
        contentSection2: 'uclfantasy',
        pageSubType: 'uclfantasy substitutions mode',
        contentSection3: '',
        pageTitle: 'UCL Classic Fantasy - Fantasy - Substitutions mode',
        pageType: 'game entry',
        pageName: '/uclfantasy/my-team/substitutions/',
        pageFormat: 'standard view',
        type: "new"
    },


}

export default newTrackEvents



// WEBPACK FOOTER //
// ./src/constants/new-pageTrackEvents.js